import RelatedListFieldComponent from './related-list-field-component';

/***
 * A list of all of the items, as well as a typeahead field for selecting and adding additional items.
 */
const relatedListField = angular
    .module('FacilityData.Common.FormFields.RelatedListField', [])
    .component('relatedListField', RelatedListFieldComponent)
    .name;

export default relatedListField;


// WEBPACK FOOTER //
// ./app/common/form-fields/related-list-field/related-list-field.js